import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Expander, ExpanderContent, ExpanderHeader, H2, Paragraph, Separator, Button } from '@fs/zion-ui'
import { ControlSplit } from '@fs/zion-icon'
import { getPersonName } from '@fs/zion-sls'
import { useR2DispatchContext } from '../../../../../../providers/r2Provider/R2Context'

const OthersOnRecordCard = ({ othersOnThisRecord, state }) => {
  const { t } = useTranslation()
  const r2Dispatch = useR2DispatchContext()

  if (othersOnThisRecord.length === 0) return null

  return (
    <Card edges="border" margins="dense">
      <Expander initiallyOpen>
        <ExpanderHeader>
          <H2 size="H5">{t('edit-relationships.others-on-this-record', 'Others on This Record')}</H2>
        </ExpanderHeader>
        <ExpanderContent>
          {othersOnThisRecord.map((page) => (
            <span key={page.partitionKey}>
              {page.partitionKey !== state.currentImageArk && (
                <>
                  <Paragraph size="xs">
                    {t('relationships.names-on-page-n.label', 'Names on Page {pageNumber}', {
                      pageNumber: page.pageNumber,
                    })}
                  </Paragraph>
                  <Button
                    Icon={ControlSplit}
                    emphasis="medium"
                    onClick={() =>
                      r2Dispatch({
                        type: 'OPEN_SPLIT_SCREEN_TO_PAGE',
                        value: page.pageNumber,
                      })
                    }
                  >
                    {t('relationships.view-in-context', 'View in Context')}
                  </Button>
                  <Separator size="xs" />
                </>
              )}
              {page.persons.map((person) => (
                <Paragraph size="sm" key={person.id}>
                  {getPersonName({ person })}
                </Paragraph>
              ))}
            </span>
          ))}
        </ExpanderContent>
      </Expander>
    </Card>
  )
}

export default OthersOnRecordCard
